/**
 * Clés i18n du 2e niveau de fil d'Ariane (Accueil > …).
 * Les pages absentes de cette liste conservent le comportement historique (parents router).
 *
 * Pour une nouvelle page : ajouter l'entrée ici ou renseigner `meta.breadcrumbTitleKey` sur la route.
 */
export const ROUTE_BREADCRUMB_TITLE_KEYS = {
  profile: 'layouts.personalInformation',
  users: 'layouts.contactBook',
  quotas: 'layouts.quotas',
  exports: 'layouts.exports',
  tutoralsVideos: 'layouts.help',
  nousContacter: 'layouts.contactUs',
  'social-reviews': 'layouts.socialManagment',
  'social-posts': 'layouts.socialManagment',
  calendrier: 'layouts.socialManagment',
  'social-networks': 'layouts.socialManagment',
  statistics: 'layouts.socialManagment',
  'integration-global-report': 'layouts.report',
  'global-report': 'layouts.report',
  'ad-lifetime-detail': 'layouts.adLifetime'
}

export function getBreadcrumbTitleKey (route) {
  if (route.meta && route.meta.breadcrumbTitleKey) {
    return route.meta.breadcrumbTitleKey
  }
  return ROUTE_BREADCRUMB_TITLE_KEYS[route.name]
}
